import {
  PILOTAGE_TUG_STAGES_REQUEST,
  PILOTAGE_TUG_STAGES_SUCCESS,
  PILOTAGE_TUG_STAGES_ERROR,
  PILOTAGE_TUG_STAGES_ADD_SUCCESS,
  PILOTAGE_TUG_STAGES_UPDATE_SUCCESS,
  PILOTAGE_TUG_STAGES_DELETE_SUCCESS,
  PILOTAGE_TUG_STAGES_REORDER_SUCCESS,
} from './actions';

const initialState = {
  data: {},
  pilotageUuid: null,
  loading: false,
  error: null,
};

export default function pilotageTugStagesReducer(state = initialState, action) {
  switch (action.type) {
    case PILOTAGE_TUG_STAGES_REQUEST:
      return { ...state, loading: true, error: null };
    case PILOTAGE_TUG_STAGES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        pilotageUuid: action.payload.pilotageUuid,
        data: Array.isArray(action.payload.data)
          ? Object.fromEntries(action.payload.data.map(stage => [stage.uuid, stage]))
          : action.payload.data,
      };
    case PILOTAGE_TUG_STAGES_ERROR:
      return { ...state, loading: false, error: action.payload };
    case PILOTAGE_TUG_STAGES_ADD_SUCCESS:
    case PILOTAGE_TUG_STAGES_UPDATE_SUCCESS:
    case PILOTAGE_TUG_STAGES_REORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
      };
    case PILOTAGE_TUG_STAGES_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
      };
    default:
      return state;
  }
}
